import { useEffect, useRef, useState } from 'react'
import Script from 'next/script'

const FORM_TARGET_ID = 'pricing-talk-to-sales-hubspot-form'

export default function TalkToSalesModal({ isOpen, onClose }) {
    const formRef = useRef(null)
    const [isFormLoading, setIsFormLoading] = useState(true)

    useEffect(() => {
        if (isOpen) setIsFormLoading(true)
    }, [isOpen])

    useEffect(() => {
        if (!isOpen) return undefined

        const previousOverflow = document.body.style.overflow
        const onKeyDown = (event) => {
            if (event.key === 'Escape') onClose()
        }

        document.body.style.overflow = 'hidden'
        document.addEventListener('keydown', onKeyDown)
        return () => {
            document.body.style.overflow = previousOverflow
            document.removeEventListener('keydown', onKeyDown)
        }
    }, [isOpen, onClose])

    const createForm = () => {
        if (!isOpen || !formRef.current || !window.hbspt?.forms) return
        if (formRef.current.dataset.rendered === 'true') {
            setIsFormLoading(false)
            return
        }

        formRef.current.innerHTML = ''
        window.hbspt.forms.create({
            portalId: '21994206',
            formId: 'd93ab0e1-6b15-46a7-80e3-215b2725e371',
            region: 'na1',
            target: `#${FORM_TARGET_ID}`,
            onFormReady: () => setIsFormLoading(false),
        })
        formRef.current.dataset.rendered = 'true'
    }

    useEffect(() => {
        if (isOpen) createForm()
    }, [isOpen])

    if (!isOpen) return null

    return (
        <>
            <Script
                id="pricing-hubspot-forms-script"
                src="//js.hsforms.net/forms/embed/v2.js"
                strategy="afterInteractive"
                onLoad={createForm}
            />
            <div
                className="fixed inset-0 z-[10000] flex items-center justify-center overflow-y-auto bg-[rgba(26,29,35,0.55)] px-4 py-6 backdrop-blur-[2px] sm:py-10"
                onMouseDown={(event) => {
                    if (event.target === event.currentTarget) onClose()
                }}>
                <section
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="pricing-sales-title"
                    className="relative max-h-[96vh] w-full max-w-[720px] overflow-y-auto rounded-[24px] bg-[#FFF6EE] p-0 text-left shadow-[0_18px_40px_rgba(0,0,0,0.22),0_2px_10px_rgba(0,0,0,0.08)]">
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Close sales form"
                        className="absolute right-4 top-4 z-20 flex h-9 w-9 items-center justify-center rounded-full bg-white/70 text-xl leading-none text-[#ED5C2F] transition-colors hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#ED5C2F]">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div className="relative overflow-visible rounded-[24px] px-8 pb-9 pt-12 sm:px-11">
                        {/* <svg
                            aria-hidden="true"
                            width="164"
                            height="124"
                            viewBox="0 0 164 124"
                            className="pointer-events-none absolute right-8 top-6 hidden sm:block"
                            xmlns="http://www.w3.org/2000/svg">
                            <g transform="rotate(-8 82 62)">
                                <rect x="20" y="26" width="124" height="76" rx="6" fill="#FFFBF6" stroke="#F2D8C0" strokeWidth="1.2" />
                                <path d="M20 32 L82 72 L144 32" fill="none" stroke="#F2D8C0" strokeWidth="1.2" />
                                <rect x="118" y="38" width="20" height="20" fill="#ED5C2F" />
                                <line x1="34" y1="86" x2="90" y2="86" stroke="#F2D8C0" strokeWidth="1.4" strokeLinecap="round" />
                                <line x1="34" y1="94" x2="76" y2="94" stroke="#F2D8C0" strokeWidth="1.4" strokeLinecap="round" />
                            </g>
                        </svg> */}
                        {/* <div className="relative max-w-[520px]">
                            <div className="mb-[10px] text-[0.78rem] font-extrabold uppercase tracking-[0.16em] text-[#ED5C2F]">
                                Enterprise plans
                            </div>
                            <h2
                                id="pricing-sales-title"
                                className="mb-2 text-[1.95rem] font-extrabold leading-[1.1] tracking-[-0.015em] text-[#3F454F] max-sm:text-[1.7rem]">
                                Let’s talk about your mailing needs.
                            </h2>
                            <p className="mb-6 text-sm leading-relaxed text-[#59616D]">
                                Share a few details and our team will help find the right fit.
                            </p>
                        </div> */}
                        <div className="relative min-h-[180px]">
                            <div
                                id={FORM_TARGET_ID}
                                ref={formRef}
                                className="min-h-[180px]"
                            />
                            {isFormLoading && (
                                <div className="absolute inset-0 flex items-start justify-center bg-[#FFF6EE] pt-6">
                                    <p
                                        role="status"
                                        className="text-sm text-[#59616D]">
                                        Loading form...
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
